import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: center;
  justify-content: center;
  align-items: center;
  background-color: #000;
`;

export const ContainerNoticia = styled.div`
  height: 60px;
  /* background: #da5527; */
  background: #ffffa8;
  width: 100%;
  font-weight: bold;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Slider = styled.div`
  height: 60px;
  background: #ffffa8;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* max-height: 200px; */
  position: relative;
`;

export const Noticias = styled.p`
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: calc(12px + 1vw);
  color: #424242;
  /* background-color: red; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 30px; */
  /* align-self: center; */
  /* align-content: center; */
  transition: opacity 800ms;
`;
